import type { CoverView, MailRule } from "../api/connectionHub.types";
import { CONNECTION_STATUS } from "../constants/connectionStatus.constants";

const ruleCovers = (rule: MailRule, covers: CoverView[]): CoverView[] =>
  covers.filter((cover) => rule.coveredIpIds.includes(cover.ipId));

export const ruleConnectionIds = (rule: MailRule, covers: CoverView[]): string[] =>
  ruleCovers(rule, covers).map((cover) => cover.connectionId);

export const isRuleConfirmed = (rule: MailRule, covers: CoverView[]): boolean => {
  const covered = ruleCovers(rule, covers);
  return covered.length > 0 && covered.every((cover) =>
    cover.status !== CONNECTION_STATUS.FORWARDING_REQUIRED &&
    cover.status !== CONNECTION_STATUS.CONFIRMING_FORWARDING
  );
};

export const currentRule = (rules: MailRule[], covers: CoverView[]): MailRule | null =>
  rules.find((rule) => !isRuleConfirmed(rule, covers)) ?? null;
